import {
  effect,
  inject,
  Injectable,
  signal,
  WritableSignal,
} from '@angular/core';
import {
  DEFAULT_LANGUAGES,
  ILanguage,
  INormalText,
  ITextLanguageValue,
} from '@web/dtos';
import { LanguageStore } from '../api/language/language-store.service';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  private readonly languageStore: LanguageStore = inject(LanguageStore);
  public readonly activeLanguage: WritableSignal<ILanguage> = signal(
    this.languageStore
      .languages()
      .filter((l: ILanguage) => l.isStandard)?.[0] || DEFAULT_LANGUAGES[0]
  );

  get languages(): ILanguage[] {
    return this.languageStore.languages();
  }
  constructor() {
    effect(() => {
      const activeLanguage: ILanguage =
        this.languageStore
          .languages()
          .filter((l: ILanguage) => l.isStandard)?.[0] || DEFAULT_LANGUAGES[0];
      this.setActiveLanguage(activeLanguage.prefix);
    });
  }
  getActiveLanguageTextValue(text: INormalText): string | undefined {
    return (
      text?.text.values.find(
        (value: ITextLanguageValue) =>
          value.languagePrefix === this.activeLanguage().prefix
      )?.value ?? undefined
    );
  }

  setActiveLanguage(isoCode: string): void {
    const lang: ILanguage | undefined = this.languageStore
      .languages()
      .find((lang: ILanguage) => lang.prefix === isoCode);
    if (lang) {
      this.activeLanguage.set(lang);
    }
  }
}
